import React from 'react';

const Analytics = () => {
  return (
   <svg xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none">
<g clip-path="url(#clip0_621_8881)">
<path d="M1.72461 12.3573C1.72461 10.8383 2.38782 9.39511 3.54042 8.40583L9.53391 3.26164C11.4849 1.58712 14.366 1.58712 16.3169 3.26164L22.3104 8.40583C23.463 9.39511 24.1262 10.8383 24.1262 12.3573L24.1262 20.4823C24.1262 22.8789 22.1834 24.8218 19.7868 24.8218L6.06405 24.8218C3.66744 24.8218 1.72461 22.8789 1.72461 20.4823L1.72461 12.3573Z" stroke="#595A5B" stroke-width="1.73577"/>
<path d="M12.9258 8.21252C14.5763 8.21252 15.9355 9.57307 15.9355 11.277C15.9353 12.9807 14.5762 14.3405 12.9258 14.3405C11.2755 14.3403 9.91723 12.9806 9.91699 11.277C9.91699 9.57315 11.2754 8.21266 12.9258 8.21252Z" stroke="#595A5B" stroke-width="1.73577"/>
<mask id="path-3-outside-1_621_8881" maskUnits="userSpaceOnUse" x="4.89258" y="15.8375" width="16" height="10" fill="black">
<rect fill="white" x="4.89258" y="15.8375" width="16" height="10"/>
<path d="M18.0871 23.9553C18.5664 23.9553 18.9612 23.5648 18.8944 23.0902C18.711 21.7874 18.1166 20.5708 17.1885 19.6294C16.0574 18.4821 14.5234 17.8375 12.9238 17.8375C11.3242 17.8375 9.79015 18.4821 8.65908 19.6294C7.73098 20.5708 7.1366 21.7874 6.95316 23.0902C6.88633 23.5648 7.28114 23.9553 7.76047 23.9553L12.9238 23.9553L18.0871 23.9553Z"/>
</mask>
<path d="M18.0871 23.9553C18.5664 23.9553 18.9612 23.5648 18.8944 23.0902C18.711 21.7874 18.1166 20.5708 17.1885 19.6294C16.0574 18.4821 14.5234 17.8375 12.9238 17.8375C11.3242 17.8375 9.79015 18.4821 8.65908 19.6294C7.73098 20.5708 7.1366 21.7874 6.95316 23.0902C6.88633 23.5648 7.28114 23.9553 7.76047 23.9553L12.9238 23.9553L18.0871 23.9553Z" stroke="#595A5B" stroke-width="3.47155" mask="url(#path-3-outside-1_621_8881)"/>
</g>
<defs>
<clipPath id="clip0_621_8881">
<rect width="26" height="26" fill="white" transform="translate(0 26.5773) rotate(-90)"/>
</clipPath>
</defs>
</svg>
  );
};

export default Analytics;

